import React from "react";
import { HStack, Heading, Text } from "@chakra-ui/react";

import {
  useAuth,
  useGetAuxiliaryComponentsByLocation,
  useQueryParam,
} from "@hooks";
import { PossibleLocationsOrAll } from "@constants";
import {
  AuxiliaryComponentsGrid,
  NewAuxComponentModal,
  Loading,
  LocationSelect,
} from "@components";
import { Layout } from "./PageLayouts";

export function AuxiliaryComponentsPage() {
  const { user, isLoggedIn } = useAuth();
  const [location, setLocation] = useQueryParam<PossibleLocationsOrAll>(
    "location",
    user ? user.location : "All",
  );

  return (
    <Layout>
      <HStack marginTop="16px" marginBottom="16px">
        <Heading flex="1">Auxiliary Components</Heading>
        <NewAuxComponentModal />
        <LocationSelect
          maxWidth={200 / 16 + "rem"}
          setLocation={setLocation}
          location={location}
        />
      </HStack>
      <InnerPageWrapper
        isLoggedIn={user ? isLoggedIn : false}
        location={location}
      />
    </Layout>
  );
}

type InnerPageWrapperProps = {
  isLoggedIn: boolean;
  location: PossibleLocationsOrAll;
};
/**
 * When `location` was being used directly to query for Auxiliary Components,
 * it was firing infinite rerenders and DB calls. This extra layer makes exists
 * just to prevent those extra calls.
 */
function InnerPageWrapper({ isLoggedIn, location }: InnerPageWrapperProps) {
  const adjustedLocation = React.useMemo(
    () => (location === "All" ? "" : location),
    [location],
  );
  const { documents: auxComponents } =
    useGetAuxiliaryComponentsByLocation(adjustedLocation);

  if (!auxComponents) return <Loading />;
  if (!isLoggedIn || auxComponents.length <= 0)
    return <Text>No Auxiliary Components Found.</Text>;

  return <AuxiliaryComponentsGrid auxiliaryComponents={auxComponents} />;
}
